import navigation from './nav';
import { modal } from './modal';
import clickToSelect from './helpers/clickToSelect';
import { cookieBanner } from './helpers/cookies';

document.addEventListener("DOMContentLoaded", () => {
  navigation()
  modal()
  clickToSelect('js-click-to-select')
  cookieBanner('cookies-eu-banner')
});
